module.exports = __webpack_public_path__ + "img/Si-n-Model.57bd637f.svg";